/** Sub-section metadata inside Part A / Part B (UI cards in images 3 & 4). */

import type { DpiaPartKey } from './dpiaPartModel';

export type DpiaPartSectionMeta = {
  sectionKey: string;
  displayCode: string;
  title: string;
  /** Legacy per-section DPIA code — used until DB uses only PART-A / PART-B rows. */
  legacyCode: string;
};

export const DPIA_PART_A_MAIN_CODE = 'PNBIL-PART-A';
export const DPIA_PART_B_MAIN_CODE = 'PNBIL-PART-B';

export const DPIA_PART_A_SECTIONS: DpiaPartSectionMeta[] = [
  {
    sectionKey: 'a1',
    displayCode: 'PNBIL-D01',
    legacyCode: 'PNBIL-D01',
    title: 'PNBIL DPIA – A1. Document & Project / Activity Owners',
  },
  {
    sectionKey: 'a2',
    displayCode: 'PNBIL-D02',
    legacyCode: 'PNBIL-D02',
    title: 'PNBIL DPIA – A2. Details of the Overall Project',
  },
  {
    sectionKey: 'a3',
    displayCode: 'PNBIL-D03',
    legacyCode: 'PNBIL-D03',
    title: 'PNBIL DPIA – A3. Personal Data Categories & Screening Questions',
  },
  {
    sectionKey: 'a4',
    displayCode: 'PNBIL-D04',
    legacyCode: 'PNBIL-D04',
    title: 'PNBIL DPIA – A4. Screening Assessment Outcome',
  },
];

export const DPIA_PART_B_SECTIONS: DpiaPartSectionMeta[] = [
  {
    sectionKey: 'b1',
    displayCode: 'PNBIL-D05',
    legacyCode: 'PNBIL-D05',
    title: 'PNBIL DPIA – B1. Context, Scope and Nature of Processing',
  },
  {
    sectionKey: 'b2',
    displayCode: 'PNBIL-D06',
    legacyCode: 'PNBIL-D06',
    title: 'PNBIL DPIA – B2. Data Sharing & International Transfers',
  },
  {
    sectionKey: 'b3',
    displayCode: 'PNBIL-D07',
    legacyCode: 'PNBIL-D07',
    title: 'PNBIL DPIA – B3. Information Security',
  },
  {
    sectionKey: 'b4a',
    displayCode: 'PNBIL-D08',
    legacyCode: 'PNBIL-D08',
    title: 'PNBIL DPIA – B4. Impact Assessment (part 1)',
  },
  {
    sectionKey: 'b4b',
    displayCode: 'PNBIL-D09',
    legacyCode: 'PNBIL-D09',
    title: 'PNBIL DPIA – B4. Impact Assessment — International transfers',
  },
  {
    sectionKey: 'b4c',
    displayCode: 'PNBIL-D10',
    legacyCode: 'PNBIL-D10',
    title: 'PNBIL DPIA – B4. Impact Assessment (part 2)',
  },
  {
    sectionKey: 'b51',
    displayCode: 'PNBIL-D11',
    legacyCode: 'PNBIL-D11',
    title: 'PNBIL DPIA – B5_1. Data Protection Privacy Risk Assessment',
  },
  {
    sectionKey: 'b52',
    displayCode: 'PNBIL-D12',
    legacyCode: 'PNBIL-D12',
    title: 'PNBIL DPIA – B5_2. Measures to Reduce Risks',
  },
];

export function sectionsForDpiaPart(part: DpiaPartKey): DpiaPartSectionMeta[] {
  return part === 'a' ? DPIA_PART_A_SECTIONS : DPIA_PART_B_SECTIONS;
}

export function mainCodeForDpiaPart(part: DpiaPartKey): string {
  return part === 'a' ? DPIA_PART_A_MAIN_CODE : DPIA_PART_B_MAIN_CODE;
}

export function legacyCodesForDpiaPart(part: DpiaPartKey): string[] {
  return sectionsForDpiaPart(part).map((s) => s.legacyCode);
}

export function sectionKeyForLegacyCode(code: string): string | null {
  const normalized = String(code ?? '').trim().toUpperCase();
  const hit =
    DPIA_PART_A_SECTIONS.find((s) => s.legacyCode === normalized) ??
    DPIA_PART_B_SECTIONS.find((s) => s.legacyCode === normalized);
  return hit?.sectionKey ?? null;
}
